import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';

import styles from '../styles/pages/product-list.scss';
import loadingStyles from '../styles/components/loading.scss';

import ProductList from '../product-list';
import SignupPromotion from '../shared/signup-promotion';
import SecondaryMenuConnector from '../../containers/menus/secondary-menu-connector';

class StoreProductsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storeCode: '',
        };
    }

    componentDidMount() {
        const { storeCode } = this.props.match.params;
        this.setState({ storeCode });
        this.props.loadStoresProducts(this.props.locale.currentLocale, storeCode);

        if (this.props.currentStore.name) {
            document.title = this.props.currentStore.name;
        }
    }

    /* If home page icon is clicked. */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname
            || prevProps.locale.currentLocale !== this.props.locale.currentLocale
            || prevProps.location.search !== this.props.location.search
        ) {
            const storeCode = this.props.location.pathname.slice(1);
            // this.props.triggerInitialSetup(this.props.locale.currentLocale);
            this.props.loadStoresProducts(this.props.locale.currentLocale, storeCode);
        }

        if (prevProps.currentStore !== this.props.currentStore) {
            document.title = this.props.currentStore.name;
        }
    }

    render() {
        return (
            <Layout notShowMarginBottom>
                <div className={styles.productList}>
                    <div className={`container body-container ${styles.bodyContainer}`}>
                        <div className="row">
                            <div className={`col-lg-3 col-md-3 col-sm-4 col-xs-12 ${styles.colFilters}`}>
                                <SecondaryMenuConnector location={this.props.location} path={this.state.storeCode} />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
                                <div className={`${styles.contentCategory}`}>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            {!this.props.displayLoader && (
                                                <label className={`${styles.titleSection}`}>
                                                    <FormattedMessage id="our" defaultMessage="Our" />
                                                    <FormattedMessage id="recommendations" defaultMessage="recommendations" />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row no-margin">
                                        {this.props.displayLoader && (
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <div>
                                                    <h4 className={styles.loadingText}>
                                                        <FormattedMessage id="loading-recommendations" defaultMessage="Loading recommendations" />
                                                        <span className="hidden-xs">
                                                            {', '}
                                                            <FormattedMessage id="please-wait" defaultMessage="please wait" />
                                                        </span>
                                                        ...
                                                    </h4>
                                                    <div className={loadingStyles.spinnerDark} />
                                                </div>
                                            </div>
                                        )}
                                        {!this.props.displayLoader && (
                                            <ProductList
                                                products={this.props.products}
                                                loadMoreProducts={this.props.loadMoreProducts}
                                                pageCount={this.props.pageCount}
                                                searchTerm={this.props.location.pathname}
                                                locale={this.props.locale}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(StoreProductsPage);



/** WEBPACK FOOTER **
 ** ./src/components/pages/store_products.jsx
 **/